const API_BASE = window.location.origin || '';

/**
 * Resolves an image URL to a fully qualified URL.
 * - Relative URLs (/api/uploads/...) → prepend API base
 * - Old preview domain URLs → convert to current API base
 * - External URLs (unsplash, pexels, etc.) → use as-is
 * - Empty/null → return fallback
 */
export function resolveImageUrl(url, fallback = '') {
  if (!url) return fallback;

  // Already a full external URL (not a preview domain)
  if (url.startsWith('http') && !url.includes('.preview.emergentagent.com')) {
    return url;
  }

  // Old preview domain URL → extract the path
  if (url.includes('.preview.emergentagent.com')) {
    const match = url.match(/\/api\/uploads\/.+/);
    if (match) {
      return `${API_BASE}${match[0]}`;
    }
    return fallback;
  }

  // Relative URL starting with /api/
  if (url.startsWith('/api/')) {
    return `${API_BASE}${url}`;
  }

  // Relative URL starting with /
  if (url.startsWith('/')) {
    return `${API_BASE}${url}`;
  }

  return url || fallback;
}
